import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Login from "./AdminComponents/Pages/Login";
import Dashboard from "./AdminComponents/Pages/Header";
import DashboardHome from "./AdminComponents/Pages/AdminDashboard";
import CategoryMaster from "./AdminComponents/Master/CategoryMaster";
import ExamForm from "./AdminComponents/Master/ExamMaster";
import SyllabusMaster from "./AdminComponents/Master/SyllabusMaster";
import MockTest from "./AdminComponents/Master/MockTestMaster";
import QuestionBank from "./AdminComponents/Master/QuestionBankMaster";
import VideoMasterForm from "./AdminComponents/Master/VideoMasterForm";
import ProtectedRoute from "./routes/ProtectedRoute";
import { AuthContext } from "./context/AuthContext";
import AdminOrgApprovals from "./AdminComponents/Pages/AdminOrgApprovals";
import StudentApproval from "./AdminComponents/Pages/StudentApproval";
import ReferralCodeGenerate from "./AdminComponents/Pages/ReferralCodeGenerate"; 
import PyqMaster from "./AdminComponents/Master/PyqMaster";
import StudyMaterialMaster from "./AdminComponents/Master/StudyMaterialMaster";
import LoginLogoutHistoryTable from "./AdminComponents/Pages/LoginLogoutHistoryTable"; 
import FacultyMaster from "./AdminComponents/Master/FacultyMaster";

import StudentMocktestVView from "./UserComponents/Master/StudentMockTestView";
import HomeAbout from "./UserComponents/Pages/HomeAbout";
import StudentDashboard from "./UserComponents/Master/StudentDashboard";
import OrganizationDashboard from "./UserComponents/Master/OrganizationDashboard";
import ExamView from "./UserComponents/Master/ExamView";
import SyllabusView from "./UserComponents/Master/SyllabusView";
import PracticeSetAttempt from "./UserComponents/Master/PracticeSetAttempt";
import VideoView from "./UserComponents/Master/VideoView";
import MockTestAttempt from "./UserComponents/Master/MockTestAttempt";
import PYQView from "./UserComponents/Master/PYQView";
import StudyMaterialView from "./UserComponents/Master/StudyMaterialView";
import FacultyView from "./UserComponents/Master/FacultyView";

const DashboardLanding = () => {
  const { user } = useContext(AuthContext);
  const role = String(user?.role || "").toLowerCase();
  const email = String(user?.email || "").toLowerCase();

  const isAdmin = email === "admin@gmail.com" || role === "admin";
  const isOrganization = role === "organization";

  if (isAdmin) return <DashboardHome />;
  if (isOrganization) return <OrganizationDashboard />;
  return <StudentDashboard />;
};

function App() {
  return (
    <Router>
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
          style: {
            fontWeight: 600,
            borderRadius: "8px",
          },
          success: {
            icon: "OK",
            style: {
              background: "#d1fae5",
              color: "#065f46",
            },
          },
          error: {
            icon: "X",
            style: {
              background: "#fee2e2",
              color: "#991b1b",
            },
          },
        }}
      />

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home-about" element={<HomeAbout />} />

        {/* MAIN ADMIN DASHBOARD */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardLanding />} />
          <Route path="category-master" element={<ProtectedRoute adminOnly><CategoryMaster /></ProtectedRoute>} />
          <Route path="exam-master" element={<ProtectedRoute adminOnly><ExamForm /></ProtectedRoute>} />
          <Route path="exam-master/:id/edit" element={<ProtectedRoute adminOnly><ExamForm /></ProtectedRoute>} />
          <Route path="exam-view" element={<ProtectedRoute adminOnly><ExamView /></ProtectedRoute>} />
          <Route path="syllabus-master" element={<ProtectedRoute adminOnly><SyllabusMaster /></ProtectedRoute>} />
          <Route path="syllabus-view/:syllabusId" element={<SyllabusView />} />
          <Route path="question-bank" element={<ProtectedRoute adminOnly><QuestionBank /></ProtectedRoute>} />
          <Route path="question-bank/new" element={<ProtectedRoute adminOnly><QuestionBank /></ProtectedRoute>} />
          <Route path="question-bank/:id/edit" element={<ProtectedRoute adminOnly><QuestionBank /></ProtectedRoute>} />
          <Route path="mock-test" element={<ProtectedRoute adminOnly><MockTest /></ProtectedRoute>} />
          <Route path="mock-test-view/:catId" element={<StudentMocktestVView />} />
          <Route path="practice-set-attempt/:subjectId" element={<PracticeSetAttempt />} />
          <Route path="mock-test-attempt/:subjectId" element={<MockTestAttempt />} />
          <Route path="mock-test-attempt/:subjectId/:testId" element={<MockTestAttempt />} />
          <Route path="video-master" element={<ProtectedRoute adminOnly><VideoMasterForm /></ProtectedRoute>} />
          <Route path="video-master/new" element={<ProtectedRoute adminOnly><VideoMasterForm /></ProtectedRoute>} />
          <Route path="video-master/:id/edit" element={<ProtectedRoute adminOnly><VideoMasterForm /></ProtectedRoute>} />
          <Route path="video-view/:examCode" element={<VideoView />} />
          <Route path="organization-approvals" element={<ProtectedRoute adminOnly><AdminOrgApprovals /></ProtectedRoute>} />
          <Route path="student-approvals" element={<ProtectedRoute adminOnly><StudentApproval /></ProtectedRoute>} />
          <Route path="referral-master" element={<ProtectedRoute adminOnly><ReferralCodeGenerate /></ProtectedRoute>} />
          <Route path="login-history" element={<ProtectedRoute adminOnly><LoginLogoutHistoryTable /></ProtectedRoute>} />
          <Route path="pyq-master" element={<PyqMaster />} />
          <Route path="pyq-master/new" element={<PyqMaster />} />
          <Route path="pyq-master/:id/edit" element={<PyqMaster />} />
          <Route path="study-material-master" element={<StudyMaterialMaster />} />
          <Route path="study-material-master/new" element={<StudyMaterialMaster />} />
          <Route path="study-material-master/:id/edit" element={<StudyMaterialMaster />} />
          <Route path="pyq-view/:catId" element={<PYQView />} />
          <Route path="study-material-view/:catId" element={<StudyMaterialView />} />
          <Route path="faculty-master" element={<FacultyMaster />} />
          <Route path="faculty-view" element={<FacultyView />} />

          
        </Route>

        {/* ORGANIZATION DASHBOARD */}
        <Route
          path="/organization-dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<OrganizationDashboard />} />
          <Route path="category-master" element={<CategoryMaster />} />
          <Route path="exam-master" element={<ExamForm />} />
          <Route path="exam-master/:id/edit" element={<ExamForm />} />
          <Route path="exam-view" element={<ExamView />} />
          <Route path="syllabus-master" element={<SyllabusMaster />} />
          <Route path="syllabus-view/:syllabusId" element={<SyllabusView />} />
          <Route path="question-bank" element={<QuestionBank />} />
          <Route path="question-bank/new" element={<QuestionBank />} />
          <Route path="question-bank/:id/edit" element={<QuestionBank />} />
          <Route path="mock-test" element={<MockTest />} />
          <Route path="mock-test-view/:catId" element={<StudentMocktestVView />} />
          <Route path="practice-set-attempt/:subjectId" element={<PracticeSetAttempt />} />
          <Route path="mock-test-attempt/:subjectId" element={<MockTestAttempt />} />
          <Route path="mock-test-attempt/:subjectId/:testId" element={<MockTestAttempt />} />
          <Route path="video-master" element={<VideoMasterForm />} />
          <Route path="video-master/new" element={<VideoMasterForm />} />
          <Route path="video-master/:id/edit" element={<VideoMasterForm />} />
          <Route path="video-view/:examCode" element={<VideoView />} />
          <Route path="student-approvals" element={<StudentApproval />} />
          <Route path="referral-master" element={<ReferralCodeGenerate />} />
          <Route path="pyq-master" element={<PyqMaster />} />
          <Route path="pyq-master/new" element={<PyqMaster />} />
          <Route path="pyq-master/:id/edit" element={<PyqMaster />} />
          <Route path="study-material-master" element={<StudyMaterialMaster />} />
          <Route path="study-material-master/new" element={<StudyMaterialMaster />} />
          <Route path="study-material-master/:id/edit" element={<StudyMaterialMaster />} />
          <Route path="pyq-view/:catId" element={<PYQView />} />
          <Route path="study-material-view/:catId" element={<StudyMaterialView />} />
          <Route path="faculty-master" element={<FacultyMaster />} />
          <Route path="faculty-view" element={<FacultyView />} />


        </Route>

        {/* STUDENT DASHBOARD */}
        <Route
          path="/student"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<StudentDashboard />} />
          <Route path="syllabus-view/:syllabusId" element={<SyllabusView />} />
          <Route path="mock-test-view/:catId" element={<StudentMocktestVView />} />
          <Route path="practice-set-attempt/:subjectId" element={<PracticeSetAttempt />} />
          <Route path="mock-test-attempt/:subjectId" element={<MockTestAttempt />} />
          <Route path="mock-test-attempt/:subjectId/:testId" element={<MockTestAttempt />} />
          <Route path="video-view/:examCode" element={<VideoView />} />
          <Route path="pyq-view/:catId" element={<PYQView />} />
          <Route path="study-material-view/:catId" element={<StudyMaterialView />} />
          <Route path="faculty-master" element={<FacultyMaster />} />
          <Route path="faculty-view" element={<FacultyView />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;